<template>
  <Header
    :bgIMG="bgImg"
    :isCenter="false"
    :subTitle="'Providence Hospital'"
    :title="'News'"
  />
  <NewsList />
  <Stats />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import Header from "@/components/CarouselHeader.vue";
import Stats from "@/components/Stats.vue";
import NewsList from "@/components/News/Template3/NewsList.vue";

export default defineComponent({
  components: {
    Header,
    Stats,
    NewsList,
  },
  data() {
    return {
      bgImg: require("@/assets/img/doctors-banner.png"),
    };
  },
});
</script>
